export default "__VITE_ASSET__CVl0pckD__"